// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// Note : Under calendar.proto and schedule.proto, location_ids are child location ids.
// ------------------------------------------------ Practitioners ------------------------------------------------
export const SchedulerService = {
    GetPractitioner(fn, req) {
        try {
            fm.validateUrlParam(req["practitionerId"], "practitionerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/practitioners/${req["practitionerId"]}?${fm.renderURLSearchParams(req, ["practitionerId"])}`, { method: "GET" });
    },
    ListPractitioners(fn, req) {
        return fn(`/schedule/v3/practitioners?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPractitionersMulti(fn, req) {
        return fn(`/schedule/v3/practitioners/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Create a practitioner for non-integrated office. For integrated office practitioner are synced from PMS.
    CreatePractitioner(fn, req) {
        return fn(`/schedule/v3/practitioners`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdatePractitioner(fn, req) {
        try {
            fm.validateUrlParam(req["practitionerId"], "practitionerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/practitioners/${req["practitionerId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeletePractitioners(fn, req) {
        return fn(`/schedule/v3/practitioners?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // For both integrated and non integrated offices, practitioner is associated with weave user.
    AssociatePractitionerWithWeaveUser(fn, req) {
        return fn(`/schedule/v3/practitioner-user-association`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ----------------------------------------- Appointment Types -----------------------------------------
    GetAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/appointment-types/${req["appointmentTypeId"]}?${fm.renderURLSearchParams(req, ["appointmentTypeId"])}`, { method: "GET" });
    },
    ListAppointmentTypes(fn, req) {
        return fn(`/schedule/v3/appointment-types?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListAppointmentTypesMulti(fn, req) {
        return fn(`/schedule/v3/appointment-types/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Create a appointment types for non-integrated office. For integrated office appointment types are synced from PMS.
    CreateAppointmentType(fn, req) {
        return fn(`/schedule/v3/appointment-types`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/appointment-types/${req["appointmentTypeId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteAppointmentTypes(fn, req) {
        return fn(`/schedule/v3/appointment-types?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // -------------------------------------------- Schedule ---------------------------------------------
    ListSchedules(fn, req) {
        return fn(`/schedule/v3/schedules?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateSchedule(fn, req) {
        return fn(`/schedule/v3/schedules`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateSchedule(fn, req) {
        return fn(`/schedule/v3/schedules`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteSchedules(fn, req) {
        return fn(`/schedule/v3/schedules?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // ----------------------------------------- Appointment Type Practitioner -----------------------------------------
    ListAppointmentTypesPractitioners(fn, req) {
        return fn(`/schedule/v3/appointment-types-practitioners?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    AssignAppointmentTypesToPractitioner(fn, req) {
        try {
            fm.validateUrlParam(req["practitionerId"], "practitionerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/practitioners/${req["practitionerId"]}/appointment-types`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    AssignPractitionersToAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/appointment-types/${req["appointmentTypeId"]}/practitioners`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UnAssignAppointmentTypesToPractitioner(fn, req) {
        try {
            fm.validateUrlParam(req["practitionerId"], "practitionerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/practitioners/${req["practitionerId"]}/appointment-types?${fm.renderURLSearchParams(req, ["practitionerId"])}`, { method: "DELETE" });
    },
    UnAssignPractitionersToAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/appointment-types/${req["appointmentTypeId"]}/practitioners?${fm.renderURLSearchParams(req, ["appointmentTypeId"])}`, { method: "DELETE" });
    },
    // ------------------------------------------------ Calendars ------------------------------------------------
    ListCalendars(fn, req) {
        return fn(`/schedule/v3/calendars?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarsByOwner(fn, req) {
        try {
            fm.validateUrlParam(req["ownerId"], "ownerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/owners/${req["ownerId"]}?${fm.renderURLSearchParams(req, ["ownerId"])}`, { method: "GET" });
    },
    GetCalendar(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}?${fm.renderURLSearchParams(req, ["calendarId"])}`, { method: "GET" });
    },
    CreateCalendar(fn, req) {
        return fn(`/schedule/v3/calendars`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendar(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteCalendar(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}?${fm.renderURLSearchParams(req, ["calendarId"])}`, { method: "DELETE" });
    },
    ListCalendarAvailabilities(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}/availabilities?${fm.renderURLSearchParams(req, ["calendarId"])}`, { method: "GET" });
    },
    // ---------------------------------------------- Operatories ----------------------------------------------
    GetOperatory(fn, req) {
        try {
            fm.validateUrlParam(req["operatoryId"], "operatoryId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/operatories/${req["operatoryId"]}?${fm.renderURLSearchParams(req, ["operatoryId"])}`, { method: "GET" });
    },
    ListOperatories(fn, req) {
        return fn(`/schedule/v3/operatories?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListOperatoriesMulti(fn, req) {
        return fn(`/schedule/v3/operatories/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Create a operatory for non-integrated office. For integrated office operatories are synced from PMS.
    CreateOperatory(fn, req) {
        return fn(`/schedule/v3/operatories`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateOperatory(fn, req) {
        try {
            fm.validateUrlParam(req["operatoryId"], "operatoryId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/operatories/${req["operatoryId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteOperatories(fn, req) {
        return fn(`/schedule/v3/operatories?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // ------------------------------------------------ CalendarEvents ------------------------------------------------
    GetCalendarEvent(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/events/${req["eventId"]}?${fm.renderURLSearchParams(req, ["eventId"])}`, { method: "GET" });
    },
    ListCalendarEvents(fn, req) {
        return fn(`/schedule/v3/calendars/events?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarEventsMulti(fn, req) {
        return fn(`/schedule/v3/calendars/events/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarEventsByOwner(fn, req) {
        try {
            fm.validateUrlParam(req["ownerId"], "ownerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/owners/${req["ownerId"]}/events?${fm.renderURLSearchParams(req, ["ownerId"])}`, { method: "GET" });
    },
    CreateCalendarEvent(fn, req) {
        return fn(`/schedule/v3/calendars/events`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendarEvent(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/events/${req["eventId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendarEventStatus(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/events/${req["eventId"]}/status`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteCalendarEvents(fn, req) {
        return fn(`/schedule/v3/calendars/events?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // ------------------------------------------------ Writebacks ------------------------------------------------
    AppointmentWriteBack(fn, req) {
        return fn(`/schedule/v3/write-backs/appointment`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    AppointmentStatusWriteBack(fn, req) {
        return fn(`/schedule/v3/write-backs/appointment-status`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    PersonWriteBack(fn, req) {
        return fn(`/schedule/v3/write-backs/person`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ------------------------------------------------ Source Tenants ------------------------------------------------
    ListSourceTenants(fn, req) {
        return fn(`/schedule/v3/source-tenants?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SetPreferredSourceTenant(fn, req) {
        return fn(`/schedule/v3/source-tenants/preferred`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    RefreshSourceTenants(fn, req) {
        return fn(`/schedule/v3/source-tenants/refresh`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // ------------------------------------------------ Settings ------------------------------------------------
    FeatureFlagStatus(fn, req) {
        return fn(`/schedule/v3/settings/feature-flag/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
